<template>
  <div :class="nowClass" @click="change(value)">
    <span></span>
    <!-- <i @click="change(value)" :class="nowClass"></i> -->
  </div>
</template>
<script>
export default {
  props: ['value'],
  computed: {
    nowClass() {
      const { value } = this;
      let str = 'icon switch ';
      if (value) {
        str += ' active';
      }
      return str;
    },
  },
  methods: {
    change(val) {
      this.$emit('change', !val);
    },
  },
};
</script>
<style lang="scss" scoped>
.switch {
  display: inline-block;
  width: 74px;
  height: 46px;
  border-radius: 23px;
  box-sizing: border-box;
  border: 2px solid #E1DEDE;
  position: relative;
  background: #fff;
  transition: 0.3s;

  span {
    transition: left 0.3s;
    position: absolute;
    display: inline-block;
    width: 42px;
    height: 42px;
    left: 0;
    top: 0px;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.35);
    border-radius: 50%;
    background: #fff;
  }

  &.active {
    background: #FF5400;
    border: 2px solid #FF5400;

    span {
      left: 30px;
    }
  }
}
</style>

